import addClass from '../../../general/class/addClass';
import hasClass from '../../../general/class/hasClass';
import removeClass from '../../../general/class/removeClass';

import * as exSelect from '../../../forms/select';

import type { Context } from '../types';

// ----------------------------------------------------------------------------

function helpers(ctx: Context): any {
    function setValue(value: string | string[]): void {
        const values = Array.isArray(value) ? value : [value];

        // Foreach Options
        for (const { element, option } of ctx.option.getOptions()) {
            let matched = false;

            for (const item of values) {
                if (item === option.value || item === option.text) {
                    matched = true;
                    break;
                }
            }

            if (matched) {
                addClass(element, 'selected active');
            } else {
                removeClass(element, 'selected active');
            }
        }

        // --------------------------------------------------------------------

        // If using type multi
        if (ctx.shared.config.type === 'multi') {
            ctx.multiple.progress();
        }
        // If using type single
        else {
            ctx.single.progress();
        }
    }

    // ------------------------------------------------------------------------

    function hasSelected(): boolean {
        const list: string[] = [];

        // Foreach Options
        for (const { element } of ctx.option.getOptions()) {
            // If there is selected
            if (hasClass(element, 'selected')) {
                list.push(element.getAttribute('value'));
                break;
            }
        }

        //
        return list.length > 0;
    }

    function getSelected(): string | string[] | undefined {
        const list: string[] = [];

        // If using type single
        if (ctx.shared.config.type === 'single') {
            // Foreach Options
            for (const { element } of ctx.option.getOptions()) {
                // If there is selected
                if (hasClass(element, 'selected')) {
                    list.push(element.getAttribute('value'));
                    break;
                }
            }

            // Return
            return list.length > 0 ? list[0] : '';
        }
        // If using type multi
        else if (ctx.shared.config.type === 'multi') {
            // Foreach Options
            for (const { element } of ctx.option.getOptions()) {
                // If there is selected
                if (hasClass(element, 'selected')) {
                    list.push(element.getAttribute('value'));
                }
            }

            // Return
            return list.length > 0 ? list : '';
        }
    }

    function setSelected(value: string): void {
        // Find option
        const findOption = ctx.option.getOptions().find(function (item): any {
            // If there is value or text
            if (item.value || item.text) {
                if (item.value == value || item.text == value) {
                    return item;
                }
            }
        });

        // If there is no find option
        if (!findOption) {
            return;
        }

        // Foreach Options
        for (const { element, option } of ctx.option.getOptions()) {
            if (option.value === findOption.value) {
                addClass(element, 'selected active');
            } else {
                removeClass(element, 'selected active');
            }
        }

        // Set text value
        ctx.text.setValue(findOption.text);
    }

    function clearSelected(): void {
        // Foreach Options
        for (const { element } of ctx.option.getOptions()) {
            removeClass(element, 'selected active');
        }

        //
        ctx.text.clearValue();
    }

    // ------------------------------------------------------------------------

    function addOptions(config: Record<string, any> = {}): void {
        // Add Options
        exSelect.addOptions(ctx.current.getElement(), config);

        // Set options
        ctx.shared.state.current.options = ctx.current.getOptions();

        // Read
        ctx.read.reset();
    }

    function resetOptions(config: Record<string, any> = {}): void {
        // Clear
        clear();

        // Reset Options
        exSelect.resetOptions(ctx.current.getElement(), config);

        // Set options
        ctx.shared.state.current.options = ctx.current.getOptions();

        // Read Start
        ctx.read.start();
    }

    // ------------------------------------------------------------------------

    function enabled(): void {
        ctx.current.getElement().removeAttribute('disabled');
        ctx.text.getTextElement().removeAttribute('disabled');
    }

    function disabled(): void {
        ctx.current.getElement().setAttribute('disabled', '');
        ctx.text.getTextElement().setAttribute('disabled', '');
    }

    // ------------------------------------------------------------------------

    function reset(): void {
        //
        ctx.current.clearValue();
        ctx.text.clearValue();
        ctx.option.reset();

        //
        ctx.search.clear();
        ctx.addOption.clear();
    }

    function clear(): void {
        //
        ctx.current.clearOptions();
        ctx.text.clearValue();
        ctx.listing.clear();
        ctx.option.clear();

        //
        ctx.search.clear();
        ctx.addOption.clear();
        ctx.request.clear();
    }

    // ------------------------------------------------------------------------

    return {
        setValue,
        hasSelected,
        getSelected,
        setSelected,
        clearSelected,
        addOptions,
        resetOptions,
        enabled,
        disabled,
        reset,
        clear,
    };
}

// ----------------------------------------------------------------------------

export default helpers;
